import React, { useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { getFormattedDate } from "../../../util/dates";
import Mark from "../../../assets/mark.png";
import PrincipalSign from "../../../assets/guillermo-sign.png";

function ReportTemplate({ ciData }) {
  function CreateCheckedTerm({ text }) {
    return (
      <View style={{ display: "flex", flexDirection: "row", width: "86%" }}>
        <View style={{ marginRight: 16 }}>
          <Image style={{ maxWidth: 30 }} src={Mark} />
        </View>
        <Text style={styles.parragraph}>{text}</Text>
      </View>
    );
  }

  function CreateParticipant({ data, desc, isSign = false }) {
    return (
      <View style={{ width: "30%" }}>
        <View
          style={{
            borderBottomWidth: 2,
            borderBottomStyle: "solid",
            marginBottom: 5,
          }}
        >
          <Text
            style={[
              styles.parragraph,
              { textAlign: "center" },
              !isSign
                ? { fontFamily: "Helvetica", fontSize: 12 }
                : { fontFamily: "Helvetica-Oblique", fontSize: 12 },
            ]}
          >
            {data}
          </Text>
        </View>
        <Text style={[styles.parragraph, { textAlign: "center" }]}>{desc}</Text>
      </View>
    );
  }

  useEffect(() => { }, [ciData]);
  return (
    <Document>
      <Page>
        <View style={styles.container}>
          <Text style={[styles.mainTitle, { textAlign: "center" }]}>
            CARTA DE CONSENTIMIENTO INFORMADO
          </Text>
          <Text style={styles.parragraph}>
            El presente consentimiento informado cumple con los lineamientos establecidos en el Reglamento de la Ley General de Salud en Materia de investigación para la Salud, la Declaración de Helsinki y las Buenas Prácticas Clínicas emitidas por la Comisión Nacional de Bioética.
          </Text>
          <Text style={styles.parragraph}>
            Para decidir si participa o no en este Programa de Experiencia Temprana para el Suplemento Alimenticio a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina, usted debe de tener el conocimiento suficiente acerca de los riesgos y beneficios que esto implica, con el fin de tomar una decisión acertada. Este documento le dará información detallada acerca del programa, la cual podrá comentar con su médico tratante o con algún miembro del equipo de investigadores. Al terminar de leer este documento se le pedirá que forme parte del proyecto y de ser así, bajo ninguna presión o intimidación, se le invitará a firmar este consentimiento informado.
          </Text>
          <Text style={[styles.title]}>
            Invitación a participar y descripción del proyecto.
          </Text>
          <Text style={styles.parragraph}>
            Estimado Sr(a).{" "}
            <Text style={{ textDecoration: "underline" }}>
              {ciData.patientCiName}
            </Text>
          </Text>
          <Text style={styles.parragraph}>
            Por medio de la presente nos dirigimos a usted para saludarle y hacerle una cordial invitación a participar en el “Programa de Experiencia Temprana para el Suplemento Alimenticio a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina”.
          </Text>
          <Text style={styles.parragraph}>
            El programa tiene como objetivos, evaluar cambios en signos y síntomas clínicos, registro de necesidad de AINEs, tolerabilidad y aceptabilidad de pacientes y opinión de médicos, en la práctica clínica habitual.
          </Text>
          <Text style={[styles.title, { marginBottom: 5 }]}>
            Procedimiento del programa
          </Text>
          <Text style={[styles.parragraph]}>
            1.	Los pacientes asistirán a 3 visitas: una inicial (día 0), una intermedia (día 30) y una final (día 90), durante el desarrollo de este PET.
          </Text>
          <Text style={[styles.parragraph]}>
            2.	Durante la visita inicial el médico dará de alta a cada paciente en la App o Sitio web.
          </Text>
          <Text style={[styles.parragraph]}>
            3.	Los pacientes, a través del médico, deberán responder un cuestionario durante cada visita.
          </Text>
          <Text style={[styles.parragraph]}>
            4.	Los cuestionarios están enfocados en evaluar lo descrito en los objetivos antes mencionados.
          </Text>
          <Text style={[styles.parragraph]}>
            5.	En caso de presentar algún efecto secundario, proporcionará la información adicional que el médico le solicite.
          </Text>
          <Text style={[styles.title, { marginBottom: 5 }]}>
            Riesgos e inconvenientes
          </Text>
          <Text style={[styles.parragraph, { marginBottom: 0 }]}>
            No se conocen riesgos e inconvenientes con el uso de este Suplemento alimenticio en la población de 40 a 80 años.
          </Text>
          <Text style={[styles.title, { marginBottom: 5 }]}>Privacidad</Text>
          <Text style={styles.parragraph}>
            Los datos acerca de su identidad y su información médica NO serán revelados en ningún momento como lo estipula la ley, por tanto, en la recolección de datos clínicos, usted no enfrenta riesgos mayores a los relativos a la protección de la confidencialidad la cual será protegida mediante la codificación de su información.
          </Text>
          <Text style={[styles.title, { marginBottom: 5 }]}>
            Beneficios potenciales
          </Text>
          <Text style={styles.parragraph}>
            El Suplemento alimenticio complementa la dieta a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina. Los cuales pueden ayudar en la mejora de la osteoartritis de rodilla grado 1 y 2, ya sea unilateral o bilateral.
          </Text>
        </View>
      </Page>
      <Page>
        <View style={styles.container}>
          <Text style={[styles.title, { marginBottom: 5 }]}>
            Participación y retiro del programa
          </Text>
          <Text style={styles.parragraph}>
            Su participación es VOLUNTARIA. Si usted decide no participar, no se afectará su relación con su médico o con su derecho a recibir atención médica o cualquier otro servicio al que tenga derecho. Si decide participar, tiene la libertad de retirar su consentimiento e interrumpir su participación en cualquier momento sin perjudicar su atención médica. Se le informará a tiempo si se obtiene nueva información que pueda afectar su decisión para continuar en el programa. El profesional de la salud puede excluirlo del programa si usted no tiene el apego suficiente a la administración. También podrá ser retirado del programa en caso de que su médico lo considere necesario para su beneficio.
          </Text>
          <Text style={[styles.title, { marginBottom: 5 }]}>
            Confidencialidad y manejo de su información
          </Text>
          <Text style={styles.parragraph}>
            Su nombre no será usado en ninguno de los programas. Su confidencialidad será protegida como lo marca la ley. Los representantes de ventas de Exeltis Pharma México podrán tener acceso a la información de los participantes. Si usted decide retirarse del programa, podrá solicitar el retiro y destrucción de su información. Todas las hojas de recolección de datos serán guardadas con las mismas medidas de confidencialidad, y solo los coordinadores titulares tendrán acceso a los datos que tienen su nombre. En el futuro, si identificamos información que consideremos importante para su salud, consultaremos con alguna Comisión de ética que supervise el programa para decidir la mejor forma de darle esta información a usted y a su médico. Además, le solicitamos que nos autorice contactarlo, en caso de ser necesario, para solicitarle información adicional que podría ser relevante para el desarrollo de este proyecto o en caso de reportar algún efecto secundario. Los datos obtenidos como parte de este programa podrían ser utilizados en publicaciones o presentaciones médicas. Su nombre y otra información personal serán eliminados antes de usar los datos.
          </Text>
          <Text style={[styles.title, { marginBottom: 5 }]}>
            Teléfonos de contacto de los investigadores
          </Text>
          <Text style={styles.parragraph}>
            El investigador responsable del proyecto es el{" "}
            <Text style={{ fontFamily: "Helvetica-Bold", fontWeight: "bold" }}>
              Dr. Guillermo de Jesús García Félix {" "}
            </Text>
            investigador  principal de Exeltis Pharma México, quien proporcionará la información actualizada que se obtenga de esta investigación y garantizará la confidencialidad de esta información. Si tiene alguna duda sobre el proceso expresado en este escrito no dude exponerla hasta resolver todas sus interrogantes a través del teléfono +52 (55) 9185 2312
          </Text>
          <Text style={styles.mainTitle}>
            Datos de contacto del Comité de ética en Investigación
          </Text>
          <Text style={[styles.parragraph, { marginBottom: 0 }]}>Nombre: Comité de Ética en Investigación Hospital La Misión, S. A. de C.V.</Text>
          <Text style={[styles.parragraph, { marginBottom: 0 }]}>Dirección: Del Hospital No.112, 1° y 2° piso, Col. Sertoma. C.P. 64718, Monterrey, Nuevo León, México.</Text>
          <Text style={[styles.parragraph, { marginBottom: 0 }]}>Presidente: Dr. José Francisco Islas Cisneros</Text>
          <Text style={[styles.parragraph, { marginBottom: 0 }]}>Teléfono: 81 1492 4050</Text>
          <Text style={[styles.parragraph, { marginBottom: 0 }]}>Correo electrónico: investigacion@hospitallamision.com</Text>
          <Text style={styles.mainTitle}>
            DECLARACIÓN DE CONSENTIMIENTO DEL SUJETO
          </Text>
          <Text style={[styles.parragraph, { marginBottom: 20 }]}>
            He leído cuidadosamente este consentimiento informado, he hecho
            todas las preguntas pertinentes y todas me han sido respondidas
            satisfactoriamente. Para poder participar en el programa, marque con
            una{" "}
            <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 10 }}>
              X
            </Text>{" "}
            si está de acuerdo con todos los siguientes puntos:
          </Text>
          <CreateCheckedTerm
            text={
              "Estoy de acuerdo en participar en el programa descrito anteriormente. Los objetivos y los posibles riesgos, inconvenientes y reacciones secundarias y adversas me han sido explicados a mi entera satisfacción. "
            }
          />
          <CreateCheckedTerm
            text={
              "Estoy de acuerdo en responder a las preguntas que me realice mi médico prescriptor. Así mismo, mi información médica podrá ser utilizada con los mismos fines."
            }
          />
          <CreateCheckedTerm
            text={
              "Estoy de acuerdo, en caso de ser necesario, que se me contacte en el futuro si el proyecto requiere colectar información adicional o si encuentran información relevante para mi salud."
            }
          />
          <CreateCheckedTerm
            text={
              "Mi firma o huella también indica que he recibido un duplicado de este consentimiento informado."
            }
          />
        </View>
      </Page>
      <Page>
        <View style={styles.container}>
          <Text style={styles.mainTitle}>Declaración del paciente</Text>
          <Text style={styles.parragraph}>
            Yo,{" "}
            <Text style={[styles.bold, { textDecoration: "underline" }]}>
              {ciData.patientCiName}
            </Text>{" "}
            declaro que es mi decisión participar en el programa. Mi participación es voluntaria.  He sido informado que puedo negarme a participar o terminar mi participación en cualquier momento del programa sin que sufra penalidad alguna o pérdida de beneficios. Si suspendo mi participación, recibiré el tratamiento médico habitual al que tengo derecho, no sufriré perjuicio en mi atención médica o en futuros programas de investigación. Yo puedo solicitar información adicional acerca de los riesgos o beneficios potenciales derivados de mi participación en el programa. Si tengo preguntas sobre el programa, puede ponerme en contacto en cualquier momento con el Dr. Guillermo de Jesús García Félix que está en el área de Traumatología y Ortopedia de Exeltis Pharma México al Teléfono +52 (55) 9185 2312. Debo informar a los investigadores de cualquier cambio en mi estado de salud o en la ciudad donde resido, tan pronto como sea posible. He leído y entendido toda la información que me han dado sobre mi participación en el programa. He tenido la oportunidad para discutirlo y hacer preguntas. Todas las preguntas han sido respondidas a mi satisfacción. He entendido que recibiré una copia firmada de este consentimiento informado.
          </Text>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.patientCiName}
              desc={"Nombre del participante o su Representante Legal"}
            />
            <CreateParticipant
              data={ciData.patientCiName}
              desc={"Firma o huella del participante o su Representante Legal"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </View>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.doctorFullName}
              desc={"Nombre del Médico prescriptor"}
            />
            <CreateParticipant
              data={ciData.doctorFullName}
              desc={"Firma del Médico prescriptor"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </View>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.firstWitnessName}
              desc={"Nombre del Testigo 1"}
            />
            <CreateParticipant
              data={ciData.firstWitnessName}
              desc={"Firma o huella del Testigo 1"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </View>
          <Text style={[styles.parragraph, { fontSize: 12 }]}>
            Relación con el participante:{" "}
            <Text>{ciData.firstWitnessRelationship}</Text>
          </Text>
          <Text style={[styles.parragraph, { fontSize: 12 }]}>
            Dirección:{"  "}
            <Text>{ciData.firstWitnessAddress}</Text>
          </Text>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.secondWitnessName}
              desc={"Nombre del Testigo 2"}
            />
            <CreateParticipant
              data={ciData.secondWitnessName}
              desc={"Firma o huella del Testigo 2"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </View>
          <Text style={[styles.parragraph, { fontSize: 12 }]}>
            Relación con el participante:{" "}
            <Text>{ciData.secondtWitnessRelationship}</Text>
          </Text>
          <Text style={[styles.parragraph, { fontSize: 12 }]}>
            Dirección:{"  "}
            <Text>{ciData.secondWitnessAddress}</Text>
          </Text>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "center",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <View style={{ height: 200, width: 200 }}>
              <Image
                style={{ maxHeight: 200, maxWidth: 200 }}
                src={PrincipalSign}
              />
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default ReportTemplate;

const styles = StyleSheet.create({
  container: {
    margin: 30,
  },
  mainTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    fontWeight: "bold",
    marginVertical: 16,
  },
  title: {
    fontSize: 12,
    marginVertical: 12,
    fontFamily: "Helvetica-Bold",
  },
  parragraph: {
    fontSize: 10,
    textAlign: "justify",
    marginBottom: 5,
    fontFamily: "Helvetica",
  },
  superScript: {
    verticalAlign: "super",
    fontSize: 6,
    fontFamily: "Helvetica",
  },
  bold: {
    fontFamily: "Helvetica-Bold",
  },
});
